/**
 * @flow
 * @relayHash 63fe69faa955964be9e40f6472d05fb9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteOrderInput = {|
  id: string
|};
export type DeleteOrderMutationVariables = {|
  input: DeleteOrderInput
|};
export type DeleteOrderMutationResponse = {|
  +deleteOrder: {|
    +deletedId: string
  |}
|};
export type DeleteOrderMutation = {|
  variables: DeleteOrderMutationVariables,
  response: DeleteOrderMutationResponse,
|};
*/


/*
mutation DeleteOrderMutation(
  $input: DeleteOrderInput!
) {
  deleteOrder(input: $input) {
    deletedId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteOrderInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteOrder",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteOrderPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteOrderMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteOrderMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteOrderMutation",
    "id": null,
    "text": "mutation DeleteOrderMutation(\n  $input: DeleteOrderInput!\n) {\n  deleteOrder(input: $input) {\n    deletedId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b05b992ebda5b56a369f5740365e0401';
module.exports = node;
